module.exports = __webpack_public_path__ + "static/media/Account-New.b71ac79f.svg";